import React, { useState, useEffect } from 'react';

import { Card } from '@blueprintjs/core';
import { Button, Tag } from '@getpingback/realeza';
import { Toastr } from '../../../services/toastr';
import Loading from '../../../components/Loading';
import DataTable from '../../../components/Table/DataTable';
import { PlusIcon } from '@stash-ui/regular-icons';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../../store/ducks/alert';
import { getChannelSegmentedLists } from '../../../services/channel';

// export const PLATFORMS = [
//   { id: 1, text: 'Substack', value: 'substack' },
//   { id: 2, text: 'Medium', value: 'medium' },
//   { id: 3, text: 'Wordpress', value: 'wordpress' },
//   { id: 4, text: 'Ghost', value: 'ghost' },
//   { id: 5, text: 'Mailchimp', value: 'mailchimp' },
// ];

const ImportData = ({ onSubmit, isLoadingFile, resetFile, onChangeType, channelUid }) => {
  const dispatch = useDispatch();

  const [platform, setPlatform] = useState('csv');
  const [file, setFile] = useState({});
  const [secondFile, setSecondFile] = useState({});
  const [channelSegmentedLists, setChannelSegmentedLists] = useState([]);
  const [channelSegmentedListId, setChannelSegmentedListId] = useState(false);

  useEffect(() => {
    listChannelSegmentedLists();
  }, []);

  useEffect(() => {
    if (resetFile) {
      setFile({});
      setSecondFile({});
    }
  }, [resetFile]);

  const listChannelSegmentedLists = async () => {
    try {
      const { data } = await getChannelSegmentedLists(channelUid);
      setChannelSegmentedLists(data.rows);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const handleSelectedFile = (e, isSecondFile) => {
    e.persist();

    if (!e.target || e.target.files.length === 0) return;

    const type = e.target.files[0].type;
    if (
      type === 'application/x-zip-compressed' ||
      type === 'application/zip' ||
      type === 'text/xml' ||
      type === 'text/csv' ||
      type === 'application/json'
    ) {
      if (!isSecondFile) setFile(e);
      else setSecondFile(e);
    } else {
      Toastr.show({ message: 'Invalid file format. Only .zip, .xml, .csv and .json are allowed', intent: 'warning' });
    }
  };

  const handleSubmitFiles = () => {
    if (file) onSubmit(file, channelSegmentedListId);
    if (secondFile) onSubmit(secondFile);
  };

  const renderFileInput = (filesAccepted, inputPlaceHolder, isSecondFile = false) => {
    let fileName = inputPlaceHolder;

    if (!isSecondFile && file.target) fileName = file.target.files[0].name;
    else if (isSecondFile && secondFile.target) fileName = secondFile.target.files[0].name;

    return (
      <div className="settings-input-file mb-16">
        <div className="bp3-input-group mt-7">
          {isLoadingFile ? (
            <Loading />
          ) : (
            <label className="bp3-file-input bp3-fill">
              <input
                type="file"
                accept={filesAccepted}
                onChange={e => {
                  handleSelectedFile(e, isSecondFile);
                }}
              />
              <span className="bp3-file-upload-input">{fileName}</span>
            </label>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <section>
        <Card className="section-card">
          <div className="card-body">
            <div className="row">
              <div className="col-12 card-header">
                <h4 className="card-title">Import CSV</h4>
                <p className="card-subtitle">Directly import to the members list or select a segmented list.</p>
              </div>
            </div>
            <div className="row">
              <div className="settings-import">
                <div className="settings-import-select">
                  <div className="settings-input">
                    {/* <SelectItem
                      listItems={PLATFORMS}
                      initialSelected={platform}
                      onChange={e => {
                        setPlatform(e.value);
                        onChangeType(e.value);
                      }}
                    /> */}
                  </div>
                </div>
                <div className="settings-import-input">
                  {Object.keys(platform).length === 0 && (
                    <div className="settings-input-file mb-16">
                      <div className="bp3-input-group mt-7">
                        <label className="bp3-file-input bp3-fill">
                          <input disabled type="file" />
                        </label>
                      </div>
                    </div>
                  )}
                  {/* {platform === 'substack' && renderFileInput('.zip', 'Substack: .zip')}
                  {platform === 'medium' && renderFileInput('.zip', 'Medium: .zip')}
                  {platform === 'wordpress' && renderFileInput('.xml', 'Wordpress: .xml')}
                  {platform === 'ghost' && (
                    <>
                      {renderFileInput('.csv', 'Ghost: .csv for members')} {renderFileInput('.json', 'Ghost: .json for text content', true)}
                    </>
                  )}
                  {platform === 'mailchimp' && renderFileInput('.zip', 'Mailchimp: .zip')} */}
                  {renderFileInput('.csv', 'Members import')}
                </div>
                <div className="settings-import-button">
                  <div className="mt-24">
                    <Button
                      disabled={!Object.keys(file || secondFile).length || Object.keys(platform).length === 0 || isLoadingFile}
                      appearence="solid"
                      className="pb-button pb-button-large"
                      onClick={handleSubmitFiles}
                    >
                      Import
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>

        {channelSegmentedLists.length > 0 && (
          <>
            <h4 className="card-title mt-24">Segmented Lists</h4>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <Tag appearence="ghost">Selected list ID: {channelSegmentedListId}</Tag>
              <Button appearence="solid" onClick={() => setChannelSegmentedListId(false)}>Remove</Button>
            </div>
            <DataTable
              body={channelSegmentedLists}
              head={['id', 'name', 'type', 'createdAt']}
              bodyColumn={['id', 'name', 'type', 'createdAt']}
              action={false}
              linkPath="custom-senders"
              customActions={[
                {
                  icon: <PlusIcon />,
                  action: item => {
                    console.log(item);
                    setChannelSegmentedListId(item.id);
                  },
                },
              ]}
            />
          </>
        )}
      </section>

      {/* <section>
        <Card className="section-card">
          <div className="card-body">
            <div className="row">
              <div className="col-12 card-header">
                <h4 className="card-title">Import</h4>
                <p className="card-subtitle">Import from Substack, Medium...</p>
              </div>
            </div>
            <div className="row">
              <div className="settings-import">
                <div className="settings-import-select">
                  <div className="settings-input">
                    <SelectItem
                      listItems={PLATFORMS}
                      initialSelected={platform}
                      onChange={e => {
                        setPlatform(e.value);
                        onChangeType(e.value);
                      }}
                    />
                  </div>
                </div>
                <div className="settings-import-input">
                  {Object.keys(platform).length === 0 && (
                    <div className="settings-input-file mb-16">
                      <div className="bp3-input-group mt-7">
                        <label className="bp3-file-input bp3-fill">
                          <input disabled type="file" />
                        </label>
                      </div>
                    </div>
                  )}
                  {platform === 'substack' && renderFileInput('.zip', 'Substack: .zip')}
                  {platform === 'medium' && renderFileInput('.zip', 'Medium: .zip')}
                  {platform === 'wordpress' && renderFileInput('.xml', 'Wordpress: .xml')}
                  {platform === 'ghost' && (
                    <>
                      {renderFileInput('.csv', 'Ghost: .csv for members')} {renderFileInput('.json', 'Ghost: .json for text content', true)}
                    </>
                  )}
                  {platform === 'mailchimp' && renderFileInput('.zip', 'Mailchimp: .zip')}
                  {platform === 'csv' && renderFileInput('.csv', 'Members import: .csv')}
                </div>
                <div className="settings-import-button">
                  <div className="mt-24">
                    <Button
                      disabled={!Object.keys(file || secondFile).length || Object.keys(platform).length === 0 || isLoadingFile}
                      appearence="solid"
                      className="pb-button pb-button-large"
                      onClick={handleSubmitFiles}
                    >
                      {'Importar'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </section> */}
    </>
  );
};

export default ImportData;
